'use client'
import {
  DecoratedSection_default
} from "./chunk-HJCFOVNG.mjs";

// src/components/faqs/FAQs.tsx
import { FAQGroups } from "@wbk/ticketing";
import { jsx } from "react/jsx-runtime";
var FAQs = ({ section }) => {
  const organizationSlug = section.organizationSlug;
  if (!organizationSlug) return null;
  return /* @__PURE__ */ jsx(DecoratedSection_default, { section, children: /* @__PURE__ */ jsx(FAQGroups, { organizationSlug: section.organizationSlug }) });
};
var FAQs_default = FAQs;

export {
  FAQs_default
};
//# sourceMappingURL=chunk-JHSFPT7T.mjs.map